import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

import { ReportsService } from '.';

export const reportListState = {
   parent: 'app',
   name: 'reports',
   url: '/reports',
   component: 'reportSelect',
   data: {
      nav: {
         title: 'Reports',
         icon: 'e360-icon-reports',
         otherStates: [ 'report' ]
      }
   }
};

export const reportState = {
   parent: 'app',
   name: 'report',
   url: '/reports/:id',
   controller: 'ReportController as ctrl',
   templateUrl: require('./report.html'),
   resolve: {
      report: getReport
   }
};

export const deviceUsageState = {
   name: 'admin.deviceUsage',
   url: '/deviceusage',
   controller: 'ReportController as ctrl',
   templateUrl: require('./report.html'),
   data: {
      disableCampaignSelection: true,
      disableBrandSelection: true,
      disableOrganizationSelection: true
   },
   resolve: {
      report: getReportResolve('device-usage')
   }
};

export const transferStatus = {
   name: 'admin.transferStatus',
   url: '/transfers',
   controller: 'ReportController as ctrl',
   templateUrl: require('./report.html'),
   data: {
      roles: 'SuperAdmin',
      disableCampaignSelection: true,
      disableBrandSelection: true,
      disableOrganizationSelection: true
   },
   resolve: {
      report: getReportResolve('transfer-status')
   }
};

getReport.$inject = ['$stateParams', 'ReportsService'];
function getReport($stateParams:uir.StateParams, reportsService:ReportsService) {
   if ($stateParams.id) {
      let report = reportsService.get($stateParams.id);
      return reportsService.getDatasets(...report.datasetIds).then(datasets => {
         report.datasets = datasets;
         return report;
      });
   }
}

function getReportResolve(reportId:string) {
   reportResolve.$inject = ['ReportsService'];
   function reportResolve(reportsService:ReportsService) {
      let report = reportsService.get(reportId);
      return reportsService.getDatasets(...report.datasetIds).then(datasets => {
         report.datasets = datasets;
         return report;
      });
   }

   return reportResolve;
}

ng.module('e360').config(configRoutes);

configRoutes.$inject = ['$stateRegistryProvider'];
function configRoutes($stateRegistry:uir.StateRegistry) {
   $stateRegistry.register(reportListState);
   $stateRegistry.register(reportState);
   $stateRegistry.register(deviceUsageState);
   $stateRegistry.register(transferStatus);
}
